import { ComplexBase } from '@syncfusion/ej2-react-base';
export class ChartDirective extends ComplexBase {
}
ChartDirective.moduleName = 'chart';
export class ChartsDirective extends ComplexBase {
}
ChartsDirective.propertyName = 'chart';
ChartsDirective.moduleName = 'charts';
